import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AuthGuard, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import {
  IconModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbDirectivesModule } from 'src/app/directives/kb-directives.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbCustomerIdDropdownModule } from '../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbMyOwnPartNumbersModule } from '../kb-MyOwnPartNumbers/kbMyOwnPartNumbers.module';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { WarrantySearchComponent } from './warranty-search.component';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';
import { KbWarrantySearchDialogComponent } from './kb-warranty-search-dialog/kb-warranty-search-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MediaModule,
    BsDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    KbCustomerIdDropdownModule,
    KbPaginationModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    KbMyOwnPartNumbersModule,
    PageSlotModule,
    KbMyAccountLeftSideNavModule,
    SpinnerModule,
    KbDirectivesModule
  ],
  exports: [WarrantySearchComponent],
  declarations: [WarrantySearchComponent, KbWarrantySearchDialogComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        SearchWarrantyClaimFlexComponent: {
          component: WarrantySearchComponent,
          guards: [SecureGuard, AuthGuard]
        },
      },
    }),
  ],
})
export class SearchWarrantyClaimModule { }
